import React from 'react'

import { Col, Row } from '_zari/core'

import FilaTemplate from './filaTemplate'

const TablaSection = ({ cuotasRef, cantidadCuotas, edicionCuotasData, infoUnicaCuota, fechaEmisionDocumento }) => {
  const actualizarFilaHandler = React.useCallback(
    ({ index, rowData }) => {
      const salida = [...cuotasRef.current]
      salida[index] = rowData

      cuotasRef.current = salida
    },
    [cuotasRef]
  )

  const tableBody = React.useMemo(() => {
    const salida = []

    for (let i = 0; i < cantidadCuotas; i++) {
      let defaultData = null
      if (edicionCuotasData && edicionCuotasData.length > 0) {
        defaultData = edicionCuotasData[i] || {}
      }

      if (i === 0 && !defaultData && infoUnicaCuota) {
        defaultData = infoUnicaCuota
      }

      salida.push(
        <FilaTemplate
          index={i}
          key={i}
          defaultData={defaultData || {}}
          actualizarFilaHandler={actualizarFilaHandler}
          flagUltimo={i === cantidadCuotas - 1}
          cuotasRef={cuotasRef}
          fechaEmisionDocumento={fechaEmisionDocumento}
        />
      )
    }

    return salida
  }, [cantidadCuotas, edicionCuotasData, actualizarFilaHandler, cuotasRef, infoUnicaCuota, fechaEmisionDocumento])

  return (
    <>
      <Row className='mt-2 mb-1'>
        <Col md={12}>
          <table width='100%'>
            <thead>
              <tr>
                <th>Nro</th>
                <th>Plazo Dias</th>
                <th>Fecha</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>{tableBody}</tbody>
          </table>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(TablaSection)
